import { CheckLayout } from '../../core/models/reference.model';

const mockCheckLayouts: CheckLayout[] = [
  { id: 'cl-001', name: 'Standard Layout', code: 'STD', isActive: true },
  { id: 'cl-002', name: 'Compact Layout', code: 'CMP', isActive: true },
  { id: 'cl-003', name: 'Extended Layout', code: 'EXT', isActive: true },
  { id: 'cl-004', name: 'Custom Layout A', code: 'CSTA', isActive: true },
  { id: 'cl-005', name: 'Custom Layout B', code: 'CSTB', isActive: true },
  {
    id: 'cl-006',
    name: 'Legacy Layout (Deprecated)',
    code: 'LEG',
    isActive: false,
  },
];

export function getMockCheckLayouts(includeInactive = false): CheckLayout[] {
  if (includeInactive) {
    return [...mockCheckLayouts];
  }
  return mockCheckLayouts.filter(layout => layout.isActive);
}

export function getMockCheckLayoutById(id: string): CheckLayout | null {
  return mockCheckLayouts.find(layout => layout.id === id) ?? null;
}
